import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/appointments/`;

export const appointments = {
  get: () => generateApiPath(pathBase),
};
